import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateLike } from "../../features/blog/blogSlice";

export default function LikeBtn({ id, likes }) {
  const dispatch = useDispatch();

  const [count, setCount] = useState(likes);

  const handleLike = () => {
    dispatch(updateLike({ id, likes: count + 1 }));
    setCount(count + 1);
  };

  return (
    <button
      className="like-btn"
      id="lws-singleLinks"
      onClick={handleLike}
    >
      <i className="fa-regular fa-thumbs-up" /> {count}
    </button>
  );
}
